'use client';

import { Header } from '@lmn/contenthub-shared/components';
import type { HeaderProps } from '@lmn/contenthub-shared/components';

interface ContentHubHeaderProps {
  headerProps: HeaderProps;
}

/**
 * Client component wrapper for Content Hub Header
 * Receives props generated server-side from CNT_CONTESTS data
 * 
 * Per Content Hub documentation (SSR pattern):
 * - Header props are fetched server-side using getHeaderProps()
 * - Props are based on contest data (brand, country, lang from CNT_CONTESTS table)
 * - Component is client-side because Header uses React Context internally
 * - DynamicLmnDsThemeProvider must wrap the app at a higher level (done in providers.tsx)
 * 
 * This follows the Next.js App Router pattern:
 * - Server Component (page.tsx) fetches data and generates props
 * - Client Component (this) receives props and renders Content Hub Header
 */
export function ContentHubHeader({ headerProps }: ContentHubHeaderProps) {
  // Don't render if props are missing or invalid
  if (!headerProps || (typeof headerProps === 'object' && Object.keys(headerProps).length === 0)) {
    return null;
  }
  
  return <Header {...headerProps} />;
}

